import _storage from 'src/utils/storage';

export const xlfowElementPushEventS = {
  // 药省卡点位
  '.xflow-medicineCard_login-send-code': ['click', 'VERIFY CODE_CLICK_YSK', '点击验证码', {}],
  '.xflow-medicineCard_login-btn': ['click', 'LOGIN_CLICK_YSK', '点击登录按钮', {}],
};

interface PushEventParams {
  event?: string;
  eventTag: string;
  text: string;
  attributes?: string;
  callback?: Function;
  attrs: {
    [key: string]: string;
  };
}
/**
 * @description 简易的xflow上报
 * @example
 * ```
 * [
 *  '事件类型',
 *  '自定义事件名；对应元数据中事件的【字段名】',
 *  '自定义事件描述；',
 *  '自定义事件属性(非必填)；对应元数据中事件属性的【属性字段名】',
 *  '字段5: 上报完成回调函数，常用于点击后需要跳转页面的场景，减少数据丢失率'
 * ];
 * sendXlfowEvent(['click', 'CUSTOMER SERVICE_CLICK_YSK', '点击客服入口', {}]);
 * ```
 * - 参考 http://wiki.zhonganonline.com/pages/viewpage.action?pageId=47026202
 */
export const sendXlfowEvent = (options) => {
  try {
    // const groupId = sessionStorage.getItem(GROUP_ID_KEY) || _storage.get(GROUP_ID_KEY);
    const [param1 = 'click', param2, param3, param4 = {}, param5] = options;
    window._XFLOW_.pushEvent([param1, param2, param3, { ...param4 }, param5]);
  } catch (error) {
    console.log('六翼上报出错', error);
  }
};

export function pushEvent({ event = 'click', eventTag, text, attrs, callback = () => {} }: PushEventParams): void {
  try {
    window._XFLOW_.pushEvent([event, eventTag, text, attrs, callback]);
  } catch (e) {
    console.log(e);
  }
}
